module.exports = __webpack_public_path__ + "static/media/13_cohizon.fe1cb118.svg";